import { ui } from '../../styles/ui'

export default function Button({
  variant = 'primary',
  size = 'md',
  type = 'button',
  className = '',
  children,
  ...props
}) {
  const variantClass = {
    primary: ui.buttons.primary,
    secondary: ui.buttons.secondary,
    ghost: ui.buttons.ghost,
    danger: ui.buttons.danger,
    icon: ui.buttons.icon,
  }[variant] || ui.buttons.primary

  const sizeClass = {
    sm: ui.buttons.sm,
    md: ui.buttons.md,
    lg: ui.buttons.lg,
  }[size] || ui.buttons.md

  return (
    <button
      type={type}
      className={`${variantClass} ${variant === 'icon' ? '' : sizeClass} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  )
}
